import api from '@/services/api'

const RESOURCE_URI = '/customer'

const fetchCustomerByDocument = (document) =>
  api.get(`${RESOURCE_URI}/${document}`)

const fetchCustomerReportsByCustomerId = (customerId) =>
  api.post(`${RESOURCE_URI}/report/by-customer`, { customerId })

const createCustomerReport = ({ storeId, customerId, reason }) =>
  api.post(`${RESOURCE_URI}/createreport`, { storeId, customerId, reason })

const deleteCustomerReport = (id) => api.delete(`${RESOURCE_URI}/report/${id}`)

export default {
  fetchCustomerByDocument,
  fetchCustomerReportsByCustomerId,
  createCustomerReport,
  deleteCustomerReport
}
